<template>

  <div class="index" v-loading="loading" element-loading-text="拼命加载中">
    <div class="title">
      <h3>物料信息</h3>
    </div>
    <div class="pdaBoxs">
      <el-form ref="form" :model="form">
        <el-form-item style="width:300px">
          <el-input v-model="form.name" placeholder="请输入物料名称搜索"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="borderBtn" @click="onSubmit">搜索</el-button>
          <el-button @click="reset" class="noneBorder">重置</el-button>
        </el-form-item>
        <div class="btnBox">
          <el-button type="primary" @click="dlqDetails()">待领取<b v-if="pageTotal>0">{{pageTotal}}</b></el-button>
          <el-button type="primary" @click="addWL()">新增物料 +</el-button>
        </div>
        <div class="clear"></div>
        <div class="typeList over_h">
          <div class="typeItem" @click="tabClick(item,index)" v-for="(item,index) in typeList" :class="tabIndex == index ? 'cur':''">
            {{item.typeName}}<b>{{item.count}}</b>
          </div>
        </div>
      </el-form>
      <div class="botCont">
        <el-table
          :data="tableData"
          height="430"
          border
          fixed
          style="width:1800px;text-align: center;">
          <el-table-column
            label="物料名称"
            width="400">
             <template slot-scope="scope">
               <div class="wlName">
                 <img :src="scope.row.picture" v-if="scope.row.picture !== ''&&scope.row.picture!=null" />
                 <img src="../../../static/images/nodata.png" v-else />
                  <div>
                    <div>{{scope.row.name}}</div>
                    <div>{{scope.row.factory}}</div>
                  </div>
               </div>
              </template>
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="分类"
            width="180">
          </el-table-column>
          <el-table-column
            prop="type"
            width="200"
            label="产品规格">
            <template slot-scope="scope">
              <div>{{scope.row.specification||'-'}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="mintagunit"
             width="180"
            label="库存单位">
          </el-table-column>
          <el-table-column
            prop="minMaxRemain"
            width="150"
            label="库存数量">
          </el-table-column>
          <el-table-column
            width="200"
            prop="createTime"
            label="上次入库时间">
          </el-table-column>
          <el-table-column
            prop="action"
            width="260"
            label="操作">
            <template slot-scope="scope">
             <div class="actionBox">
               <div v-if="tabIndex==3||tabIndex==4" class="cursor" @click="ruku(scope.row)">入库</div>
                <div class="cursor" @click="xiafaBtn(scope.row)">下发</div>
               <!-- <div class="cursor" @click="edit(scope.row)">编辑</div> -->
               <div class="cursor" @click="deleteM(scope.row)">删除</div>
              <!-- <div class="cursor" @click="xiafa()">下发</div>
               <div class="cursor" @click="chuku()">出库</div> -->
             </div>
             </template>

          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total" :page-size="15" :page-count="total" @current-change="currentPage" @prev-click="prev" @next-click="next">
      </el-pagination>
    </div>
    <!--待领取弹框-->
    <el-dialog :visible.sync="showDlqDialog" width="70%" @click="closeDialog('showForm')">
       <el-form label-width="120px" :model="showForm" ref="showForm">
          <div class="maskBoxs showDetails">
           <div class="maskBoxAbsolute">
              <h1 id="202112060001001">待领取<b>{{pageTotal}}</b></h1>
            </div>
            <div style="margin-top: 20px;">
              <div class="botCont">
                <el-table
                  :data="dlq_tableData"
                  height="430"
                  border
                  fixed
                  style="width:1800px;text-align: center;">
                  <el-table-column
                    type="index"
                    label="序号"
                    width="60">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="物料名称"
                    width="260">
                   <template slot-scope="scope">
                     <div class="wlName">
                       <img :src="scope.row.picture" v-if="scope.row.picture !== ''&&scope.row.picture!=null" />
                       <img src="../../../static/images/nodata.png" v-else />
                        <div>
                          <div>{{scope.row.name}}</div>
                        </div>
                     </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="typeName"
                    label="分类">
                  </el-table-column>
                  <el-table-column
                    prop="prsNum"
                    label="下发数量">
                  </el-table-column>
                  <el-table-column
                    prop="mintagunit"
                    label="入库单位">
                  </el-table-column>
                  <el-table-column
                    prop="realName"
                    label="下发人">
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="下发时间">
                  </el-table-column>
                  <el-table-column
                    prop="action"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="primary" @click="get(scope.row)">领取</el-button>
                     </template>

                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  :page-size="10"
                  layout="prev, pager, next"
                  @current-change="currentPages"
                  @prev-click="prevs"
                  @next-click="nexts"
                  :total="pageTotal" style="margin-top:50px">
                </el-pagination>
              </div>
            </div>
          </div>
       </el-form>
    </el-dialog>

    <!---新增物料弹框-->
    <el-dialog :visible.sync="showAddDialog" width="960px" @click="closeDialog('showForm')">
       <el-form label-width="120px" :model="showForm" ref="showForm">
          <div class="maskBox">
            <h1 style="font-size:20px;">新增物料</h1>
            <div>

              <div class="layui-form-item leftBlock" style="width: 98%;">
                <div class="over_h">
                  物料名称
                  <span class="red">*</span>
                  <!-- <div class="fr color99">0/20</div> -->
                </div>
                <div class="layui-input-block mar_t15">
                  <input type="text" name="wulName" v-model="newData.name" lay-verify="wulName" autocomplete="off"  class="layui-input wulName">
                </div>
              </div>
              <div class="layui-form-item leftBlock">
                <div class="over_h">
                  生产厂家
                  <div class="fr color99">0/20</div>
                </div>
                <div class="layui-input-block mar_t15">
                  <input type="text" name="Manufacturer" v-model="newData.factory" lay-verify="Manufacturer" autocomplete="off"  class="layui-input Manufacturer">
                </div>
              </div>
              <div class="layui-form-item layui-inline leftBlock">
                <div class="">请选择分类 <span class="red">*</span></div>
                <div class="layui-input-block mar_t15 typess">
                  <div v-for="(item,index) in typess" @click="types(index)" :class="active == index ? 'cur':''">{{item}}</div>
                </div>
                <div class="tit">药品、疫苗请通过 <a>小牧丁APP</a> 添加</div>
              </div>
              <div class="layui-form-item layui-inline leftBlock numsss">
                 <el-form-item label="数量">
                   <el-input v-model="newData.prsNum"></el-input>
                  </el-form-item>
                <div class="descriptB">例如：袋、盒、套等包装描述</div>
              </div>
              <div class="layui-form-item layui-inline leftBlock">
                 <el-form-item label="最小入库单位">
                    <el-select v-model="newData.mintagunit" placeholder="请选择单位">
                      <el-option  v-for="(item,index) in unitList" :key="index" :label="item.valueDesc" :value="item.valueDesc"></el-option>
                    </el-select>
                  </el-form-item>
                <div class="descriptB">例如：袋、盒、套等包装描述</div>
              </div>
              <div class="clear"></div>
              <div class="rkConfrim addConfrim clear cur" @click="confirmBtn">确定</div>
            </div>
          </div>
       </el-form>
    </el-dialog>
    <!-- 下发列表 -->
    <el-dialog :visible.sync="showCFLSDialog" width="90%" height="900" @click="closeDialog(showRKForm)">
     <div class="maskBoxs showDetails">
      <div class="maskBoxAbsolute">
         <h1 id="202112060001001">下发列表</h1>
       </div>
      <el-table
        :data="xiafaLS"
        height="600"
        border
        fixed
        style="width:1800px;text-align: center;">
         <el-table-column
          prop="recordNo"
          width="150"
          label="">
        </el-table-column>
        <el-table-column
          label="物料名称"
          width="360">
         <template slot-scope="scope">
           <div class="wlName">
             <img :src="scope.row.picture" v-if="scope.row.picture !== ''&&scope.row.picture!=null" />
             <img src="../../../static/images/nodata.png" v-else />
              <div>
                <div>{{scope.row.name}}</div>
                <div>{{scope.row.factory}}</div>
              </div>
           </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="factory"
          width="150"
          label="厂家">
          <template slot-scope="scope">
            <div>{{scope.row.factory||'-'}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="mintagunit"
           width="120"
          label="库存单位">
        </el-table-column>
        <el-table-column
          prop="minMaxRemain"
          width="120"
          label="库存数量">
        </el-table-column>
        <el-table-column
          width="180"
          prop="createTime"
          label="入库时间">
        </el-table-column>
        <el-table-column
          prop="action"
          width="260"
          label="操作">
          <template slot-scope="scope">
           <div class="actionBox">
              <div class="cursor" @click="xiafa(scope.row)">下发</div>
             <!-- <div class="cursor" @click="edit(scope.row)">编辑</div> -->
           </div>
           </template>
        </el-table-column>
      </el-table>
      </div>
    </el-dialog>

    <!--入库弹框-->
    <el-dialog :visible.sync="showRKDialog" width="500" height="400" @click="closeDialog(showRKForm)">
      <el-form label-width="120" :model="showRKForm" ref="showRKForm">
        <div class="maskBox" style="width:100%!important;min-width:100%!important;height: 400px !important;">
        	<h1 style="font-size:20px;">入库</h1>
        	<div class="detailT">{{item.typeName}}&emsp;|&emsp; {{item.name}}&emsp;|&emsp;最大单位：{{item.mintagunit}}</div>
         <!-- <div class="detailT"> 物料名称:&emsp; {{item.name}}</div>
          <div class="detailT"> 库存单位:{{item.mintagunit}} </div> -->
        	<div class="rkInputBlock">
            <div class="rkInputText mar_r20">入库数量</div>
            <div style="width:calc(100% - 100px);" >
              <div class="rkInput">
                <input class="rkInputT rkInputY" v-model="num" value="" />
                <div class="danWei">{{item.mintagunit}}</div>
              </div>
            </div>
        	</div>
        	<div class="rkConfrim rkddd cur" style="margin-top:20px!important;" @click="rkConfirmBtn">确定</div>
        </div>
      </el-form>
    </el-dialog>

    <!--入库成功弹框-->
    <el-dialog :visible.sync="showRKSuccessDialog" width="40%" height="400" @click="closeDialog(showRKSuccessForm)">
      <el-form label-width="120" :model="showRKSuccessForm" ref="showRKSuccessForm">
        <div class="maskBox" style="width:100% !important;height: 400px !important;">
        	<h1 style="font-size:20px;">入库成功！</h1>
        	<div class="rkInputBlock rkInputBlock2">
            <img src="../../../static/images/ok.png" />
            <div>已成功入库&nbsp;{{num}}&nbsp;&nbsp;{{item.mintagunit}}</div>
            <div>入库记录编号：RK20210920004412</div>
        	</div>
        	<div class="rkConfrim rkddd finish cur" style="margin-top:20px!important;" @click="rkConfirmBtnClose()">完成</div>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="showLQSuccessDialog" width="40%" height="300" @click="closeDialog(showLQSuccessForm)">
      <el-form label-width="120" ref="showLQSuccessForm">
        <div class="maskBox" style="width:100% !important;height: 300px !important;">
        	<!-- <h1 style="font-size:20px;"></h1> -->
        	<div class="rkInputBlock rkInputBlock2">
            <img src="../../../static/images/ok.png" />
            <div>领取成功！</div>
            <!-- <div>入库记录编号：RK20210920004412</div> -->
        	</div>
        	<div class="rkConfrim rkddd finish cur" style="margin-top:20px!important;" @click="lqConfirmBtnClose()">完成</div>
        </div>
      </el-form>
    </el-dialog>




    <!--下发信息弹框-->
    <el-dialog :visible.sync="showXFDialog" width="60%" height="400" @click="closeDialog(showXFForm)">
      <el-form label-width="120" :model="showXFForm" ref="showXFForm">
        <div class="maskBox" style="height: 400px !important;">
        	<h1 style="font-size:20px;">补充下发信息</h1>
          <div class="det">
            <img :src="item.picture" v-if="item.picture !== ''&&item.picture!=null" />
            <img src="../../../static/images/nodata.png" v-else />
            <div>
              <h3>{{item.name}}</h3>
              <h6>类型：{{items.typeName}}&emsp;&emsp;&emsp;库存单位：{{item.mintagunit}}</h6>
            </div>
          </div>
        	<div class="rkInputBlock" style="margin:30px 60px 10px 60px;overflow: inherit;">
            <div class="rkInputText mar_r20">选择领取人</div>
            <div style="width:calc(100% - 100px);" >
              <div class="wlInfoSeleVale" @click="xiafaVal" v-if="xiafaValue.avatarUrl==''">
                <span style="margin-left: 10px;">请选择领取人</span>
              </div>
              <div class="wlInfoSeleVale" @click="xiafaVal" v-else>
                <img v-if="xiafaValue.avatarUrl!=''&&xiafaValue.avatarUrl!=null" :src="xiafaValue.avatarUrl" />
                <img v-else src="../../assets/img/u8.png" alt="">
                <p>{{xiafaValue.realName}}</p>
                <span>{{xiafaValue.authProvincesCityAreasName}}</span>
              </div>
              <div class="wlInfoSele" v-show="xiafaShow">
                <div class="wlInfoSeleTit">请选择领取人</div>
                <ul>
                  <li v-for="(item,index) in xiafaList" @click="xiafaLi(index,item)">
                    <img v-if="item.avatarUrl!=''&&item.avatarUrl!=null" :src="xiafaValue.avatarUrl" />
                    <img v-else src="../../assets/img/u8.png" alt="">
                    <!-- <img :src="item.avatarUrl||'../../assets/img/u8.png'" /> -->
                    <p>{{item.realName}}</p>
                    <span>{{item.authProvincesCityAreasName}}</span>
                  </li>
                </ul>
              </div>
              <img class="arr" :class="{'trans':transShow==true}" src="../../../static/images/arr2.png" />
            </div>
        	</div>
          <div style="overflow: hidden;clear: both;"></div>
          <div class="rkInputBlock" style="margin:20px 60px">
            <div class="rkInputText mar_r20" style="width: 70px;text-align: right;">下发数量</div>
            <div style="width:calc(100% - 100px);">
              <div class="rkInput">
                <input v-model="xfNum" ref="xfInput" class="rkInputT rkInputY" value="" />
                <div class="danWei">{{item.mintagunit}}</div>
              </div>
            </div>
          </div>
          <div class="infoTit">当前库存{{item.minMaxRemain}} {{item.mintagunit}}</div>
        	<div class="rkConfrim rkddd cur" style="margin-top:20px!important;" @click="xfConfirmBtn">确定</div>
        </div>
      </el-form>
    </el-dialog>

    <!--下发成功弹框-->
    <!-- <el-dialog :visible.sync="showXFSuccessDialog" width="40%" height="400" @click="closeDialog(showXFSuccessForm)">
      <el-form label-width="120" :model="showXFSuccessForm" ref="showXFSuccessForm">
        <div class="maskBox" style="width:500px !important;height: 400px !important;">
        	<h1 style="font-size:20px;">下发成功！</h1>
        	<div class="rkInputBlock rkInputBlock2">
            <img src="../../assets/img/ok.png" />
            <div>已成功下发&nbsp;10&nbsp;单位&nbsp;物料名称1物料名称1</div>
            <div>下发记录编号：XF20210920004412</div>
        	</div>
        	<div class="rkConfrim rkddd finish cur" style="margin-top:20px!important;" @click="xfConfirmBtnClose()">完成</div>
        </div>
      </el-form>
    </el-dialog> -->

  </div>
</template>
<!-- <script src="https://cdn.bootcss.com/hls.js/8.0.0-beta.3/hls.min.js"></script> -->
<script>
  import Vue from 'vue'
  import {
    pageMatterInfo,
    countMatterInfoByC,
    pageList,
    materialCollection,
    saveMatterRecord,
    findDictList,
    getUserListByAreasId,
    materialDelivery,
    delMatterInfo,
    pageForOut,
    getUserList
  } from '@/api/material'
  export default {
    data() {
      return {
        forms: {
          authProvincesCityAreas:'',
          realName: '',
          phone: '',
          queryCityAreas:'',
           pageNo: 1,
           pageSize: 50,
          optAuthType:null,
          deptId:''

        },
        newData:{
          name:'',
          factory:'',
          typeCode:'',
          mintagunit:'',
          prsNum:''
        },
        rules: {
          parentId: [
            { required: true, message: '请输入父级节点', trigger: 'blur' }
          ],
          deptId: [
            { required: true, message: '请输入节点编号', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '请输入部门名称', trigger: 'blur' },
            { min: 3, max: 32, message: '长度在 3 到 32 个字符', trigger: 'blur'}
          ],
          sort: [
            { required: true, message: '请输入排序值', trigger: 'blur' }
          ],
          applicationId: [
            { required: true, message: '请选择项目Id', trigger: 'blur' }
          ],
        },
        num:'',
        item:'',
        pageTotal:0,
        infoQuery:{
          name:'',
          pageNo:1,
          pageSize:15,
          typeCode:''
        },
        pageQuery:{
          pageNo:1,
          pageSize:10,
        },

        active:-1,
        loading:false,
        options: null,
        open: true,
        exit: false,
        transShow:false,
        fullscreen: false,
        videoIndex:'0',
        typeList:[],
        tabIndex:0,
        form: {
          name:''
        },
        pageNum: 1,
        total: 0,
        totalPage:1,
        elementList: [],
        xiafaShow:false,
        xiafaValue:{
          avatarUrl:''
        },
        xiafaList:[ ],
        xiafaLS:[],
        tableData: [],
        dlq_tableData: [],
        typess:['设备','工具'],
        receive:'',
        xfNum:'',
        showForm: {
          id: '',
        },
        showForm2: {
          id: '',
        },
        showRKForm:{
          id:''
        },
        showCKForm:{
          id:''
        },
        showXFForm:{
          id:''
        },
        showDelForm:{
          id:''
        },
        showRKSuccessForm:{
          id:''
        },
        showCKSuccessForm:{
          id:''
        },
        showXFSuccessForm:{
          id:''
        },
        showAddDialog: false, //控制新增物料显示与隐藏
        showDlqDialog:false, //控制待领取
        showFormVisible2:false,
        showRKDialog:false,
         showLQSuccessDialog:false,
        showCKDialog:false,
        showXFDialog:false,
        showDeleteDialog:false,
        showRKSuccessDialog:false,
        showCKSuccessDialog:false,
        showXFSuccessDialog:false,
        showCFLSDialog:false,
        unitList:[],
        newS:0,
        items:'',
        infoLocal:null
      }
    },

    mounted() {
       this.infoLocal = JSON.parse(localStorage.getItem('info'))
       console.log('3434334')
       console.log(this.infoLocal)
       this.forms.authProvincesCityAreas = this.infoLocal.authProvincesCityAreas
      this.getList()
      this.getType()
      this.pageLs()
      this.unitLs()
    },
    methods: {
      xfInput(e){
        console.log(e)
        // this.xfNum = e.detail
      },
      lqConfirmBtnClose(){
        this.showLQSuccessDialog = false
        this.getList()
        this.pageLs()
      },
      xfLs(){
        pageForOut({
          matterId:this.items.id,
          pageNo:1,
          pageSize:20
        })
        .then(res => {
            this.xiafaLS = res.data.data.records
        })
        .catch(err => {
          _this.loading = false
          // _this.$message.error('加载失败，请稍后再试！')
        })
      },
      xiafaBtn(item){
        this.showCFLSDialog = true
        this.items = item
        this.xfLs()
      },
      unitLs(){
        findDictList({
          code:'unit_type'
        })
          .then(res => {
              this.unitList = res.data.data[0].children
          })
          .catch(err => {
            _this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })
      },
      tabClick(item,index){
        this.tabIndex = index
        this.infoQuery.typeCode = item.typeCode
        this.getList()
      },
     async getType(){
      await countMatterInfoByC()
        .then(res => {
          this.typeList = res.data.data
          let num = 0
          this.typeList.forEach(item=>{
             num += item.count
          })
          let row = {
            typeName:'全部类型',
            typeCode:'',
            count:num
          }
          this.typeList.unshift(row)
        })
        .catch(err => {
          _this.loading = false
          // _this.$message.error('加载失败，请稍后再试！')
        })
      },
      // 待领取列表
      pageLs(){
        pageList(this.pageQuery)
          .then(res => {
           this.dlq_tableData = res.data.data.records
           this.pageTotal = res.data.data.total
          })
          .catch(err => {
            this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })
      },

      // 关闭弹出框
      closeDialog() {
        this.showAddDialog = false
        this.showDlqDialog = false
        this.showFormVisible2 = false
        this.showRKDialog = false
        this.showCKDialog = false
        this.showDeleteDialog = false
        this.showLQSuccessDialog = false
      },
      //待领取
      dlqDetails:function(index){
        this.showDlqDialog = true
      },

      //领取
      get(item){
        var _this = this
        materialCollection({
          orderItems:[
            {
              id:item.id.toString(),
              matterRecordId:item.distributeMatterRecordId.toString(),
              prsNum:"1"
            }

          ],
          type:10
        })
          .then(res => {
             // this.dlq_tableData = res.data.data.records
             _this.showDlqDialog = false
             // this.pageTotal = res.data.data.total
             _this.showLQSuccessDialog = true
          })
          .catch(err => {
            _this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })
      },

      //新增物料
      addWL:function(){
        this.showAddDialog = true
        this.newS = 0
      },
      //确定
      confirmBtn(){
        if(this.newData.name==''){
           this.$message('请输入物料名称')
        }else if(this.newData.factory==''){
          this.$message('请输入生产厂家')
        }else if(this.newData.prsNum==''&&this.newData.prsNum<1){
          this.$message('请输入数量，数量必须大于0')
        }else if(this.newData.mintagunit==''){
          this.$message('请选择单位')
        }else if(this.newData.typeCode==''){
          this.$message('请选择类型')
        }else{
          let infoQuery = {
            name:this.newData.name,
            factory:this.newData.factory,
            prsNum:this.newData.prsNum,
            mintagunit:this.newData.mintagunit,
            typeCode:this.newData.typeCode
          }
          this.saveMaterial(infoQuery)
          this.getType()

        }

      },
      saveMaterial(infoQuery){
      saveMatterRecord(infoQuery)
        .then(res => {
          if(this.newS==0){
            this.showRKDialog = false
            this.showAddDialog = false
            this.showRKSuccessDialog = true
            this.showFormVisible2 = false
            this.showRKDialog = false
            this.showCKDialog = false
            this.getList()
          }else{
             this.showRKDialog = false
             this.showRKSuccessDialog = true
             this.showAddDialog = false
             this.showFormVisible2 = false
             this.showRKDialog = false
             this.showCKDialog = false
          }
        })
        .catch(err => {
          this.loading = false
          // _this.$message.error('加载失败，请稍后再试！')
        })
      },
      //选择分类
      types:function(index){
        this.active = index
        if(index==0){
          this.newData.typeCode = 3
        }else{
          this.newData.typeCode = 4
        }
      },


      //入库
      ruku(item){
        console.log(item)
        this.item = item
        this.showRKDialog = true
        this.newS = 1

      },
      //入库确定
      rkConfirmBtn(){
        if(this.num<1){
           this.$message('数量必须大于0')
        }else{
          let infoQuery= ''
          if(this.item.typeName=='工具'||this.item.typeName=='设备'){
             infoQuery = {
              name:this.item.name,
              factory:this.item.factory,
              prsNum:this.num,
              mintagunit:this.item.mintagunit,
              typeCode:this.item.typeCode
            }
              this.saveMaterial(infoQuery)
          }
        }
      },

      //入库完成
      rkConfirmBtnClose(){
        this.showRKSuccessDialog = false
        this.getList()
      },


      //出库
      chuku(){
        this.showCKDialog = true
      },
      //出库确定
      ckConfirmBtn(){

       this.showCKDialog = false
       this.showCKSuccessDialog = true
      },
      //出库完成
      ckConfirmBtnClose(){
        this.showCKSuccessDialog = false
      },



      //下发
      xiafa(item){
        this.item = item
        this.showXFDialog = true
        this.xiafaLs()
      },
      // 下发领取
      xiafaLs(){
        var _this = this
        getUserList(this.forms)
        .then( res => {
          _this.xiafaList = res.data.data.records
        })
      },
      //下发领取人
      xiafaVal(){
        this.xiafaShow = !this.xiafaShow
        this.transShow = !this.transShow
      },
      xiafaLi(index,item){
        this.receive = item
        this.xiafaValue.avatarUrl = item.avatarUrl
        this.xiafaValue.realName = item.realName
        this.xiafaValue.authProvincesCityAreasName = item.authProvincesCityAreasName
        this.xiafaShow = false
        this.transShow = false
      },


      //下发确定
      xfConfirmBtn(){
        // this.xfNum = this.$ref.xfInput;

        if(this.xfNum<1){
           this.$message('数量必须大于0')
        }else if(this.receive.id==''||this.receive.id==undefined){
          this.$message('请选择下发人')
        }else if(this.xfNum>this.item.minMaxRemain){
          this.$message('数量不能大于库存' + this.item.minMaxRemain)
        }else{
          materialDelivery(
          {
            matterId:this.items.id,
            receiveBy:this.receive.id,
            orderItems:[{
              id:this.item.id.toString(),
              matterRecordId:this.items.id.toString(),
              prsNum:this.xfNum,
              recordNo:this.item.recordNo
            }],
            type:20
          })
          .then(res => {
              this.showXFDialog = false
              this.showXFSuccessDialog = true
              this.xfLs()
          })
          .catch(err => {
            this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })
        }
      },
      //下发完成
      xfConfirmBtnClose(){
        this.showXFSuccessDialog = false
      },
      deleteM(item){
        this.$confirm('是否删除本条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delMatterInfo(item.id) .then(res => {
              this.getList()
              this.showXFDialog = false
              this.showXFSuccessDialog = true
               this.getType()
               this.$message({
                 type: 'success',
                 message: '删除成功!'
               });
          })
          .catch(err => {
            this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      },
      // 点击显示视频
    video(item,id,hls,index){
      this.videoIndex = index
       item.videoShow = !item.videoShow
        if(hls.indexOf('.andmu.cn')==-1){
          this.$nextTick(() => {
             this.appendDomToRoot(document.querySelector("#myVideo"+id), ".imgV",hls,id);
          })
        }else{

        }
    },
      // 页码
      currentPage(e){
        this.loading = true
        this.pageNum = e
        this.getList()
      },
      prev(e){
        this.loading = true
        this.pageNum = e
        this.getList()
      },
      next(e){
        this.loading = true
        this.pageNum = e
        this.getList()
      },
      currentPages(e){
        this.pageQuery.pageNo = e
        this.pageLs()
      },
      prevs(e){
       this.pageQuery.pageNo = e
       this.pageLs()
      },
      nexts(e){
       this.pageQuery.pageNo = e
       this.pageLs()
      },

      onSubmit() {
        this.infoQuery.name = this.form.name
        this.getList()
      },
      reset(){
        this.form.name = ''
        this.infoQuery.name = ''
        this.getList()
      },
      async getList() {
        var _this = this
        await pageMatterInfo(_this.infoQuery)
          .then(res => {
            console.log(res)
            _this.loading = false
            if (res.data.code == 0) {
              _this.tableData = res.data.data.records
              console.log(_this.tableData)
            } else {
              _this.$message({
                type: 'info',
                message: res.data.msg
              })
            }
          })
          .catch(err => {
            _this.loading = false
            // _this.$message.error('加载失败，请稍后再试！')
          })
      },
    },
    // 注册组件
    components: {

    },
    created() {

    },
  }
</script>

<style scoped>
  /deep/ .el-tabs__active-bar{
    width: 80px;
  }
  /deep/ .el-button--success.is-plain{
    border-color: rgba(48, 191, 48, 1);
    color: #30BF30 !important;
    background: #fff;
  }
  /deep/ .el-button--info.is-plain{
    background: rgba(245, 245, 245, 1);
    color:#333;border-color:rgba(245, 245, 245, 1)
  }
  .layuiPdaList{
    height: calc( 100vh - 384px );
    overflow-y: auto;
  }
  @media (max-width: 1500px) {
    .layuiPdaList{
      height: calc( 100vh - 445px );
    }
  }
  .title {
    height: 60px;
    line-height: 60px;
    margin: 0;
  }

  .title h3 {
    margin: 0 !important;
  }

  .title h3 span {
    font-weight: normal;
    font-size: 16px;
    margin-left: 10px;
  }

  /deep/.el-main {
    background: #f7f7f7 !important;
  }

  .pdaBoxs {
    background: #fff;
    padding: 20px 20px 10px 20px;
  }
  .typeList{
    margin-bottom: 22px;
  }
  .typeList div {
    cursor: pointer;
    float: left;
    padding: 0px 20px;
    border: 1px solid #F5F7FA;
    background: #F5F7FA;
    color: #333;
    border-radius: 5px;
    margin-right: 20px;
    height: 38px;
    line-height: 38px;
    font-size: 16px;
  }
  .typeList div.cur {
    background-color: #fff;
    border: 1px solid #30bf30;
    color: #30bf30;
  }
  .typeList div b{
    margin-left: 10px;
  }
  .wlName{
    display: inline-block;
    width: 100%;
  }
  .wlName img{
    width: 100px;height:100px;
    object-fit: cover;
    float: left;
  }
  .wlName > div{
    float: left;margin-left: 20px;
    text-align: left;    width: calc( 100% - 120px );
  }
  .wlName > div > div:nth-child(1){
    font-size: 16px;color:#333;font-weight: 700;
    margin-top: 10px;
  }
  .wlName > div > div:nth-child(2){
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
  }
  .actionBox > div{
    display: inline-block;margin-bottom: 10px;
    border-right: solid 1px #999;
    height: 12px;
    line-height: 12px;
    padding: 0 10px;
    cursor: pointer;
  }
  .actionBox > div:last-child{
    border:none
  }
  .actionBox div div{
    display: inline-block;
  }
  .btnBox{
    float: right;font-size: 16px
  }
  .btnBox button{
    font-size: 16px;height:40px;padding: 0 20px;
    line-height: 40px;
  }
  .btnBox button:nth-child(1){
    width: auto;background: none;
    color:#666;
    border: solid 1px rgba(217, 217, 217, 1);
    border-radius: 20px;
  }
  .maskBox h1, .maskBoxs h1 {
    font-size: 16px;
    color: #333;
    text-align: center;
    font-weight: 700;
    margin: 0 0 15px 0;
  }
  .btnBox button b,
  .maskBoxs h1 b{
    height: 20px;line-height: 21px;padding: 0 10px;
    background: linear-gradient(270deg, rgba(217, 33, 33, 1) 0%, rgba(255, 74, 38, 1) 100%);
    color:#fff;border-radius: 10px;margin-left: 10px;
    display: inline-block;
  }


  /deep/ .el-tabs__item{
     width: 80px;
     height: 60px;
     text-align: center;
     font-size: 17px;
     padding: 5px 0;
     cursor: pointer;
   }
   /deep/ .el-tabs__item.is-active{
     color: #30BF30;
     font-weight: bold;
   }
   /deep/ .el-tabs__active-bar{
     width: 80px;
   }
   /deep/ .el-tabs__nav-wrap::after{
     height:1px
   }
   .el-button--primary:focus,
   .el-button--primary:hover{
     background-color: #30BF30;
     border-color: #30BF30;
   }
   /deep/ .el-tabs__active-bar{
     width: 100px;
   }
   /deep/ .el-button--success.is-plain{
     border-color: rgba(48, 191, 48, 1);
     color: #30BF30 !important;
     background: #fff;
   }
   /deep/ .el-button--info.is-plain{
     background: rgba(245, 245, 245, 1);
     color:#333;border-color:rgba(245, 245, 245, 1)
   }
   .wuInfoBtns div{
     display: inline-block;
     cursor: pointer;
     margin-left: 20px;
   }
   .wuInfoBtns div img {
     display: inline-block;
     width: 20px!important;
     height: 20px!important;
     margin: 0 auto;
     margin-right: 5px;
     vertical-align: sub;
   }
   .maskBox {
     width: 100%!important;
     height: 550px!important;
   }
   .leftBlock {
     float: left;
     width: 48%;
     font-size: 16px;
     color: #333;
     margin-top: 25px;
     margin-bottom: 0!important;
     padding-bottom: 10px;
     margin-right: 4%;
     position: relative;
     clear: none!important;
   }
   .leftBlock:nth-child(2n-1) {
     margin-right: 0!important;
   }
   .leftBlock .red {
     color: red;
   }
   .color99 {
     color: #999;
   }
   .mar_t15 {
     margin-top: 10px;
   }
   .layui-input-block {
     position: relative;
     margin-left: 0!important;
     min-height: 36px;
   }
   .layui-input-block.inputRadio > div{
     cursor: pointer;
     position: relative;display: inline-block;
   }
   .layui-input-block.inputRadio > div > input{
     width: 50px;position: relative;
     z-index: 99999;cursor: pointer;
   }
   .layui-input-block.inputRadio > div > input::after{
     content: '';
     position: absolute;
     left: 13px;
     top:-3px;
     width: 20px;height: 20px;
     background: url(../../../static/images/radius.svg) no-repeat center;
     background-size: 20px auto;
   }
   .layui-input-block.inputRadio > div > input[type="radio"]:checked::after{
     background: url(../../../static/images/radius_checked.png) no-repeat center;
     background-size: 20px auto
   }
   .layui-input-block.inputRadio > div > span{
     position: absolute;
     right: 0px;
   }

   .layui-input, .layui-textarea, select {
     height: 40px;
     border-radius: 5px;
   }
   .layui-input, .layui-textarea,select{
     display: block;
     width: 100%;
     text-indent: 10px;
   }
   .layui-input, .layui-textarea,select {
    border:solid 1px #e6e6e6;
    outline: none;
    background: transparent!important;
   }
   .descriptB {
     position: absolute;
     bottom: -20px;
     left: 0;
     color: #999999;
     font-size: 16px;
   }
   .ds_I {
     display: inline-block;
   }
   .baozhuang>input{
     height: 36px;
     width: 100px!important;
     float: left;
     text-indent: 10px;
     margin-right: 15px;
     border:solid 1px #e6e6e6
   }
   .baozhuang>select{
     height: 40px;
     width: 100px!important;
     float: left;
     margin-right: 15px;
   }
   .baozhuang>select:last-child{
     margin-right: 0;
   }
   .baozhuang span{
     float: left;margin-right: 15px;
     margin-top: 10px;
   }
   .rkConfrim.cur {
     cursor: pointer;
     background: #30BF30;
     color: #fff;
   }
   .addConfrim {
     margin-top: 70px!important;
   }
   .rkConfrim {
     color: #999999;
     background: #F5F7FA;
     border-radius: 5px;
     width: 100px;
     height: 40px;
     line-height: 40px;
     margin: 0px auto 0;
     text-align: center;
     position: relative;
   }
   .rkInputBlock {
     overflow: hidden;
     margin: 60px 60px;
   }
   .rkInputBlock>div {
     float: left;
     position: relative;
     line-height: 40px;
   }
   .rkInputBlock2 img{
     width: 80px;display: block;
     margin: 0 auto 20px;
   }
   .rkInputBlock.rkInputBlock2 > div{
     font-size: 16px;color:#333;
     text-align: center;
   }
   .rkInputBlock.rkInputBlock2>div{
     float: none;
   }
   .mar_r20 {
     margin-right: 20px;
   }
   .rkInput {
     width: 100%;
     border: 1px solid #D9D9D9;
     border-radius: 5px;
     margin-bottom: 15px;
     position: relative;
   }
   .rkInput input {
     border: none!important;
     text-indent: 20px;
     width: 80%;
     height: 35px;
     outline: none;
   }
   .danWei {
     position: absolute;
     top: 0;
     right: 15px;
     color: #999999;
   }
   .bgF5 {
     background: #F5F7FA!important;
   }
   .rknumss div {
     height: 40px;
     line-height: 40px;
     margin-bottom: 20px;
     cursor: pointer;
   }
   .rknumss label {
     display: inline-block;
     width: 20px;
     height: 20px;
     border-radius: 50%;
     background: url(../../../static/images/radius.svg) no-repeat center;
     background-size: 20px 20px;
     float: left;
     cursor: pointer;
     margin-right: 10px;
     margin-top: 10px;
   }
   .rknumss div.checked label {
     background: url(../../../static/images/radius_checked.png) no-repeat center;
     background-size: 20px 20px;
   }
   .rknumss span {
     font-size: 15px;
     color: #333;
     float: left;
   }
   .rknumss input {
     width: 60%;
     height: 40px;
     line-height: 40px;
     background-color: rgba(255, 255, 255, 0);
     border: solid 1px rgba(217, 217, 217, 1);
     border-radius: 5px;
     text-align: center;
     font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
     font-size: 18px;
     float: right;
     outline: none;
     padding: 0;
   }
   .rknumss input:disabled {
     background-color: rgba(245, 247, 250, 1);
   }
   .hide{
     display: none;
   }
   .delBtnBox {
     text-align: center;
   }
  .delBtnBox div{
    display: inline-block;margin: 0 10px;
    cursor: pointer;
  }
  .tit{
    font-size: 16px;color:#999;
  }
  .tit a{
    color:#30BF30
  }
  .typess div{
    cursor: pointer;
    display: inline-block;
    padding: 0px 15px;
    border: 1px solid #F5F7FA;
    background: #F5F7FA;
    color: #333;
    border-radius: 5px;
    margin-right: 20px;
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .typess div.cur{
    background-color: #fff;
    border: 1px solid #30bf30;
    color: #30bf30;
  }
  .rkConfrim.rkddd.finish.cur{
    background: none;
    height: 38px;line-height: 38px;
    border:solid 1px #30BF30;
    color:#30BF30
  }
  .det{
    margin: 0;
    padding: 15px 20px;
    font-size: 16px;
    background: #f5f7fa;
    border-radius: 5px;
    overflow: hidden;
  }
  .det img{
    width: 50px;height: 50px;
    float: left;
  }
  .det > div{
    float: left;
    width: calc( 100% - 60px );
    margin-left: 10px;
  }
  .det > div h3{
    margin: 0;
    font-size: 16px;
    font-weight: normal;
    color: #333;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .det > div h6{
    margin: 10px 0 0 0;
    font-size: 16px;
    font-weight: normal;
    color: #999;
  }
  .infoTit{
    font-size: 16px;color:#999;text-align: center;
    margin-bottom: 40px;
  }
  .wlInfoSeleVale{
    height: 40px;
    line-height: 40px;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    font-size: 15px;
    text-align: left;
    cursor: pointer;
  }
  .wlInfoSele{
    width: calc( 100% + 2px );
    height: 250px;
    overflow:auto;
    background-color: #fff;
    box-sizing: border-box;
    border:solid 1px rgba(217, 217, 217, 1);
    border-radius: 5px;
    padding: 0 10px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9999999;
  }
  .wlInfoSele ul{
    margin: 0;
  }
  .wlInfoSele ul li{
   line-height: 59px;
   border-bottom: solid 1px #D9D9D9;
   margin: 0;
   cursor: pointer;
   width: 100%;
   overflow: hidden;
  }
  .wlInfoSele ul li:last-child{
    border:none
  }
  .wlInfoSele ul li img,
  .wlInfoSeleVale img{
    width: 20px;height: 20px;border-radius: 50%;
    float: left;
    margin: 20px 0 0 0;
  }
  .wlInfoSeleVale img{
    margin: 10px 0 0px 10px;
  }
  .wlInfoSele ul li p,
  .wlInfoSeleVale p{
    font-size: 16px;color:#333;margin: 0 10px;
    float: left;
    margin: 0 20px 0 10px;
  }
  .wlInfoSele ul li span,
  .wlInfoSeleVale span{
    font-size: 16px;color:#999;
    display: inline-block;
    width: calc( 100% - 196px );
    line-height: 30px;
    margin-top: 17px;
  }
  .wlInfoSeleVale p{
    width: 110px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .wlInfoSeleVale span{
    margin-top: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 40px;
    width: calc( 100% - 200px );
  }
  .wlInfoSeleTit{
    font-size: 16px;
    color: #999;
    text-align: left;
    border-bottom: solid 1px #D9D9D9;
  }
  .arr{
    width: 6px;
    height: auto;
    position: absolute;
    right: 10px;
    top: 17px;
    transition: all 300ms;
    transform: rotate(90deg);
  }
  .arr.trans{
    transform: rotate(-90deg);
  }
  .detailT {
    /* margin: 0 15px 0px 30px; */
    margin:0!important;
    padding: 10px 10px!important;
    font-size: 16px;
    background: #f5f7fa;
    border-radius: 5px;
    text-align: center;
  }
  .showDetails .detailT{
    margin: 0 15px 0px 15px;
  }
  .detailT span{
    padding: 0 10px 0 6px;
    border-right: solid 1px #606266;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    line-height: 16px;
  }
  .detailT span:last-child{
    border:none
  }
  /deep/ .el-form-item__label{
    text-align:left!important;
    font-size:16px!important;
  }
  /deep/ .el-table th.el-table__cell,
  /deep/ .el-table th.el-table__cell.is-leaf{
    text-align: center;
  }
  /deep/ .el-table th.el-table__cell>.cell{
    text-align: center;
  }
  /deep/ .el-table th.el-table__cell,
  /deep/ .el-table th.el-table__cell.is-leaf{
    background: #f5f7fa;
  }
  .el-table td.el-table__cell div{
    text-align: center;
  }
  .el-table td.el-table__cell div .wlName div{
    text-align: left;
  }
  /deep/ .el-message-box{
    width:300px!important;
  }
  /deep/ .has-gutter tr th:nth-child(1) div{
    text-align: left !important;
  }
  /deep/ .el-table--border .el-table__cell{
    border-right:none
  }
  /deep/ .el-table th.el-table__cell.is-leaf,
  /deep/ .el-table--border{
    border: none;
  }
  /deep/ .el-table--border::after,
  /deep/ .el-table--group::after,
  /deep/ .el-table--border::after,
  /deep/ .el-table--group::after,
  /deep/ .el-table::before{
    display: none;
  }
  /deep/ .numsss .el-form-item__label{
    width: auto !important;
  }
  /deep/ .numsss .el-form-item__content{
    float: left;
    margin-left: 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/material/info.vue